module.exports = __webpack_public_path__ + "img/home_bg.c4d2a8a8.png";